import React from "react";

type BaseProps = React.InputHTMLAttributes<HTMLInputElement> &
    React.TextareaHTMLAttributes<HTMLTextAreaElement> &
    React.SelectHTMLAttributes<HTMLSelectElement>;

interface InputFieldProps extends Omit<BaseProps, "type"> {
    placeholder?: string;
    type?: string;
    disabled?: boolean;
    label?: string;
    name?: string;
    className?: string;
    step?: string;
    options?: Array<string | { label: string; value: string }>;
}

const AuthInputField: React.FC<InputFieldProps> = ({
    placeholder,
    type = "text",
    disabled,
    label,
    name,
    className,
    step,
    options,
    ...rest
}) => {
    const safeId = `${name || label || type}-${Math.random()
        .toString(36)
        .slice(2, 7)}`;

    return (
        <div className="form-group">
            {label && <label className="form-label" htmlFor={name}>{label}</label>}

            {type === "select" && options ? (
                <select
                    id={safeId}
                    name={name}
                    className={`form-select appearance-none ${className}`}
                    disabled={disabled}
                    {...rest}
                >
                    <option value="">{placeholder || "Select an option"}</option>
                    {options.map((option, index) =>
                        typeof option === "string" ? (
                            <option key={index} value={option}>
                                {option}
                            </option>
                        ) : (
                            <option key={index} value={option.value}>
                                {option.label}
                            </option>
                        )
                    )}
                </select>
            ) : (
                <input
                    type={type}
                    className={`form-control ${className}`}
                    placeholder={placeholder}
                    disabled={disabled}
                    id={safeId}
                    step={step}
                    name={name}
                    {...rest}
                />
            )}
        </div>
    );
};

export default AuthInputField;
